import { render, staticRenderFns } from "./orderForm.vue?vue&type=template&id=1bb140b7&scoped=true&"
import script from "./orderForm.vue?vue&type=script&lang=js&"
export * from "./orderForm.vue?vue&type=script&lang=js&"
import style0 from "./orderForm.vue?vue&type=style&index=0&id=1bb140b7&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bb140b7",
  null
  
)

export default component.exports